import { render, staticRenderFns } from "./FilesTab.vue?vue&type=template&id=06bf85f5&scoped=true"
import script from "./FilesTab.vue?vue&type=script&lang=js"
export * from "./FilesTab.vue?vue&type=script&lang=js"
import style0 from "./FilesTab.vue?vue&type=style&index=0&id=06bf85f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf85f5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Lifting/FilesTab.vue
// module id = 668
// module chunks = 31